import { Tooltip } from "antd";
import type { ReactNode } from "react";
import OffsetIcon from "components/svg-icons/offset-icon";
import { DATE_FORMAT_MMDDYYYY, DateUtils } from "utils/dateutils";

function ActivityOffsetTag(props: {
  task: any;
  isShowDate?: boolean;
  showTooltip?: boolean;
  dateTextClassName?: string;
  tooltipTitle?: ReactNode;
}) {
  const {
    task,
    isShowDate,
    showTooltip = true,
    dateTextClassName,
    tooltipTitle
  } = props;
  const duration =
    task?.offset_duration < 0
      ? // negative branch only runs when offset_duration<0 (truthy), so `|| ""` fallback is unreachable
        /* v8 ignore next */
        `${task?.offset_duration || ""}`
      : `+${task?.offset_duration || ""}`;
  const usesLinkCardDateStyle = Boolean(dateTextClassName);

  const tag = (
    <div
      className={
        usesLinkCardDateStyle
          ? "flex shrink-0 flex-nowrap items-center bg-ciq-gray-200 rounded-sm px-[2px] text-xs whitespace-nowrap"
          : "flex shrink-0 flex-nowrap items-center justify-center font-normal text-[10px] px-[2px] bg-ciq-gray-200 rounded-sm whitespace-nowrap"
      }
    >
      <span className="flex shrink-0 items-center">
        <OffsetIcon />
      </span>
      {isShowDate ? (
        <span
          className={
            dateTextClassName ??
            "shrink-0 whitespace-nowrap text-black opacity-90 tabular-nums"
          }
        >
          {DateUtils.format(task?.linked_offset_date, DATE_FORMAT_MMDDYYYY)}
        </span>
      ) : (
        <span className="shrink-0 whitespace-nowrap text-black opacity-88">
          {duration}
        </span>
      )}
    </div>
  );

  if (tooltipTitle) {
    return <Tooltip title={tooltipTitle}>{tag}</Tooltip>;
  }

  if (!showTooltip) return tag;

  return (
    <Tooltip
      title={
        // `duration` is always a non-empty string (it is either "+"-prefixed or
        // a negative number), so the `|| ""` fallback is unreachable
        /* v8 ignore next */
        `Activity Offset by ${duration || ""} days.`
      }
    >
      {tag}
    </Tooltip>
  );
}
export default ActivityOffsetTag;
